import './styles.scss';
import React, {useState} from 'react';
import {useQuery} from "react-query";
import AlertApi from "../../../api/Alert/Alert.api";
import useUserStore from "../../../data/User.store";
import DefaultLoader from "../../common/DefaultLoader/DefaultLoader";
import AlertsTable from "../Alerts.table/Alerts.table.component";
import AlertsFilters from "../Alerts.filters/Alerts.filters";
import {Collapse} from "antd";
import {AlertsFiltersManagerClass} from "../Alerts.filters/Alerts.filters.manager";
import {AlertsFiltersTypes} from "../Alerts.filters/Alerts.filters.types";
import {SearchOutlined} from "@ant-design/icons";

interface Props {
    userId?: string,
}

function UsersAlerts({userId}: Props) {
    const {user} = useUserStore();

    let userFiltersSerializableDates = [AlertsFiltersTypes.AlertForDate]
    let userFiltersSerializableJoins = []

    let curAlertsFilterManager = new AlertsFiltersManagerClass({
        serializable: {dates: userFiltersSerializableDates, joins: userFiltersSerializableJoins},
        localStorageKey: `alerts_filters_${userId || user.id}`,
    })

    const [page, setPage] = useState(1);
    const [query, setQuery] = useState({});
    const [collapsed, setCollapsed] = useState(curAlertsFilterManager.initialQuerySent);


    function onPagination(page: number) {
        setPage(page);
    }

    const {isLoading, data} = useQuery(
        [
            `fetchAlerts-${userId || user.id}`,
            query,
            parseInt(userId) || user.id,
        ], AlertApi.getAlerts
    )

    if (isLoading && !data?.records) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text='Loading user...'/>
            </div>
        )
    }

    const pagination = {
        onChange: onPagination,
        pageSize: 25,
        total: data.totalRecords,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        current: page,
    }

    function onSubmitQuery(values: any) {
        let serializedQuery = curAlertsFilterManager
            .setDeserializedValues(values)
            .serializeQuery()
            .setQueryToLocalStorage()
            .getValuesForStrapiQuery()
        setQuery(serializedQuery);
        setCollapsed(true);
    }

    function getLocalStorageQuery() {
        return curAlertsFilterManager
            .getQueryFromLocalStorage()
            .getValues();
    }

    function getAlertsFiltersInitialValues() {
        return curAlertsFilterManager
            .setSerializedValues(getLocalStorageQuery())
            .deserializeQuery()
            .getValues()
    }
    function onCollapseChange(keys){
        if (keys.indexOf("1") !== -1){
            setCollapsed(false);
        } else {
            setCollapsed(true);
        }
    }

    return (
        <div className='user-alerts'>
            <div className='user-alerts-header'>
                <div className='title'>
                    Alerts
                </div>
                <div className='filters'>
                    <Collapse ghost activeKey={collapsed ? null : 1} onChange={onCollapseChange}
                              expandIconPosition='right'>
                        <Collapse.Panel key={1} header={<div className='global-search-criteria-dropdown-header'>
                            <SearchOutlined/>Edit Search Criteria</div>}>
                            <AlertsFilters onSubmitQuery={onSubmitQuery}
                                           initialValues={getAlertsFiltersInitialValues()}/>
                        </Collapse.Panel>
                    </Collapse>

                </div>
            </div>
            <div className='user-alerts-content'>
                <AlertsTable data={data.records} pagination={pagination}/>
            </div>
        </div>
    )
}

export default UsersAlerts;